import { ActiveReasons } from "../models/BookingReasons";
import { CaptchaDetailsForm } from "../models/CaptureDetailsForm";
import { IDTypes, RequestorType } from "../models/Enums";
import { ErrorResponse } from "../models/ErrorResponse";
import { FormState } from "final-form";

export const getErrorModalTitle = (errorState: null | ErrorResponse) => {
  const check =
    typeof errorState?.error === "string" &&
    errorState?.error?.indexOf("|") > -1;
  if (errorState?.errortitle) return errorState?.errortitle;
  return check ? errorState?.error?.split("|")[0] : "Error";
};

export const getErrorModalInnerHTML = (errorState: null | ErrorResponse) => {
  if (errorState?.error) {
    console.log(errorState?.error);
    return errorState?.error?.indexOf("|") > -1
      ? errorState?.error?.split("|")[1].replace(/\n/g,"<br />")
      : errorState?.error.replace(/\n/g,"<br />");
  }
  return "Error";
};

export const getFormattedDate = (date: string | Date): string => {
  const newDate = new Date(date);
  const month = newDate.toLocaleString("default", { month: "long" });
  const dateString = `${newDate.getDate()} ${month} ${newDate.getFullYear()}`;
  return dateString;
};

export const getFormattedTime = (time: string): string => {
  const times = time.split(":");
  if (Number(times[0]) < 12) {
    return `${times[0]}:${times[1]} AM`;
  }
  return `${times[0]}:${times[1]} PM`;
};

const emptyStringCheck = (value: string) => {
  return value === null || value === "";
}

const delegateIDSame = (requestorID: string, taxPayerID: string, delegateID: string): boolean => {
  const emptyDelegate = emptyStringCheck(delegateID);
  const emptyTaxpayer = emptyStringCheck(taxPayerID);
  const emptyRequestor = emptyStringCheck(requestorID);
  if(emptyRequestor && emptyDelegate && emptyTaxpayer) return false;
  return (delegateID === taxPayerID && !emptyDelegate && !emptyTaxpayer) || (requestorID === delegateID && !emptyDelegate && !emptyRequestor);
}

export const invalidTaxPractitioner = (form: FormState<Record<string, any>, Partial<Record<string, any>>> | null | undefined): boolean => {
  if(form?.values?.requestorType === RequestorType.TaxPractitioner) {
    const taxPracIDType = form?.values?.taxPractInfo_idType;
    const taxPayerIDType = form?.values?.taxpayer_idType;
    if(taxPracIDType === IDTypes.SAIdentificationNumber) return taxPayerIDType === IDTypes.SAIdentificationNumber && form?.values?.taxPractInfo_idNumber === form?.values?.taxpayer_idNumber && !delegateIDSame(form?.values?.taxPractInfo_idNumber, form?.values?.taxpayer_idNumber, form?.values?.delegate_idNumber);
    if(taxPracIDType === IDTypes.PassportNumber) return taxPayerIDType === IDTypes.PassportNumber && form?.values?.taxPractInfo_passportNo === form?.values?.taxpayer_passportNo && !delegateIDSame(form?.values?.taxPractInfo_passportNo, form?.values?.taxpayer_passportNo, form?.values?.delegate_passportNo);
    if(taxPracIDType === IDTypes.AsylumSeeker) return taxPayerIDType === IDTypes.AsylumSeeker && form?.values?.taxPractInfo_asylumNo === form?.values?.taxpayer_asylumNo && !delegateIDSame(form?.values?.taxPractInfo_asylumNo, form?.values?.taxpayer_asylumNo, form?.values?.delegate_asylumNo);
  }
  return false;
}

export const invalidRepresentative = (form: FormState<Record<string, any>, Partial<Record<string, any>>> | null | undefined): boolean => {
  if(form?.values?.requestorType === RequestorType.Representative) {
    const representativeIDType = form?.values?.registeredRepresentInfo_idType;
    if(representativeIDType === IDTypes.SAIdentificationNumber) return form?.values?.taxpayer_idType === IDTypes.SAIdentificationNumber && form?.values?.registeredRepresentInfo_idNumber === form?.values?.taxpayer_idNumber && !delegateIDSame(form?.values?.registeredRepresentInfo_idNumber, form?.values?.taxpayer_idNumber, form?.values?.delegate_idNumber);
    if(representativeIDType === IDTypes.PassportNumber) return form?.values?.taxpayer_idType === IDTypes.PassportNumber && form?.values?.registeredRepresentInfo_passportNo === form?.values?.taxpayer_passportNo && !delegateIDSame(form?.values?.registeredRepresentInfo_passportNo, form?.values?.taxpayer_passportNo, form?.values?.delegate_passportNo);
    if(representativeIDType === IDTypes.AsylumSeeker) return form?.values?.taxpayer_idType === IDTypes.AsylumSeeker && form?.values?.registeredRepresentInfo_asylumNo === form?.values?.taxpayer_asylumNo && !delegateIDSame(form?.values?.registeredRepresentInfo_asylumNo, form?.values?.taxpayer_asylumNo, form?.values?.delegate_asylumNo);
  }
  return false;
}

export const invalidTaxPractitionerDelegate = (form: FormState<Record<string, any>, Partial<Record<string, any>>> | null | undefined): boolean => {
  if(form?.values?.requestorType === RequestorType.TaxPractitioner) {
    const taxPracIDType = form?.values?.taxPractInfo_idType;
    const taxPayerIDType = form?.values?.taxpayer_idType;
    if(taxPracIDType === IDTypes.SAIdentificationNumber || taxPayerIDType === IDTypes.SAIdentificationNumber) return form?.values?.delegate_idType === IDTypes.SAIdentificationNumber && delegateIDSame(form?.values?.taxPractInfo_idNumber, form?.values?.taxpayer_idNumber, form?.values?.delegate_idNumber);
    if(taxPracIDType === IDTypes.PassportNumber || taxPayerIDType === IDTypes.PassportNumber) return form?.values?.delegate_idType === IDTypes.PassportNumber && delegateIDSame(form?.values?.taxPractInfo_passportNo, form?.values?.taxpayer_passportNo, form?.values?.delegate_passportNo);
    if(taxPracIDType === IDTypes.AsylumSeeker || taxPayerIDType === IDTypes.AsylumSeeker) return form?.values?.delegate_idType === IDTypes.AsylumSeeker && delegateIDSame(form?.values?.taxPractInfo_asylumNo, form?.values?.taxpayer_asylumNo, form?.values?.delegate_asylumNo);
  }
  return false;
}

export const invalidRepresentativeDelegate = (form: FormState<Record<string, any>, Partial<Record<string, any>>> | null | undefined): boolean => {
  if(form?.values?.requestorType === RequestorType.Representative) {
    const representativeIDType = form?.values?.registeredRepresentInfo_idType;
    const taxPayerIDType = form?.values?.taxpayer_idType;
    if(representativeIDType === IDTypes.SAIdentificationNumber || taxPayerIDType === IDTypes.SAIdentificationNumber) return form?.values?.delegate_idType === IDTypes.SAIdentificationNumber && delegateIDSame(form?.values?.registeredRepresentInfo_idNumber, form?.values?.taxpayer_idNumber, form?.values?.delegate_idNumber);
    if(representativeIDType === IDTypes.PassportNumber || taxPayerIDType === IDTypes.PassportNumber) return form?.values?.delegate_idType === IDTypes.PassportNumber && delegateIDSame(form?.values?.registeredRepresentInfo_passportNo, form?.values?.taxpayer_passportNo, form?.values?.delegate_passportNo);
    if(representativeIDType === IDTypes.AsylumSeeker || taxPayerIDType === IDTypes.AsylumSeeker) return form?.values?.delegate_idType === IDTypes.AsylumSeeker && delegateIDSame(form?.values?.registeredRepresentInfo_asylumNo, form?.values?.taxpayer_asylumNo, form?.values?.delegate_asylumNo);
  }
  return false;
}

export const getIDDisplay = (id: string): string => {
  if(id === IDTypes.SAIdentificationNumber) return "South African Identification Number";
  return id === IDTypes.PassportNumber ? "Passport Number": "Asylum Seeker Number";
}

export const getIdentificationNumber = (form: CaptchaDetailsForm): string => {
  if(form.requestorType === RequestorType.Individual || form.requestorType === RequestorType.SMMESoleProprietor){
    switch(form.individual_idType)
    {
      case "id_number": {
        return form.individual_idNumber ?? "";
      }
      case "passport_number": {
        return form.individual_passportNo ?? "";
      }
      default:
        return form.individual_asylumNo ?? "";
    }
  }

  if(form.companyRegNo) return form.companyRegNo;
  if(form.trustRegNo) return form.trustRegNo;

  switch(form.taxpayer_idType){
    case "id_number": {
      return form.taxpayer_idNumber ?? "";
    }
    case "passport_number": {
      return form.taxpayer_passportNo ?? "";
    }
    default:
      return form.taxpayer_asylumNo ?? "";
  }
}

export const getBookingTypeByReasonId = (
  reasons: ActiveReasons[],
  id: number
): string => {
  return (
    reasons.find((reason: ActiveReasons) => reason.ReasonPermutationID === id)
      ?.ChannelType ?? ""
  );
};

export const getReasonCategoryByReasonId = (
  reasons: ActiveReasons[],
  id: number
): string => {
  return (
    reasons.find((reason: ActiveReasons) => reason.ReasonPermutationID === id)
      ?.ReasonCategory ?? ""
  );
};

export const getReasonDescriptionByPermutationID = (
  reasons: ActiveReasons[],
  id: number
): string => {
  return (
    reasons.find((reason: ActiveReasons) => reason.ReasonPermutationID === id)
      ?.ReasonDescription ?? ""
  );
};

export const getRequester = (representativeType: string | null | undefined, requesterType: string): string => {
  if(representativeType && representativeType !== "") return representativeType;
  if(requesterType === "Individuals") return "Individual";
  return requesterType;
}

export const getEntity = (entityType: string | null | undefined, requesterType: string, trustType: string | null | undefined, smmeType: string | null | undefined): string => {
  if(requesterType === RequestorType.Individual || requesterType === RequestorType.SMMESoleProprietor) return "Individual";
  if(entityType === "Individual" || entityType === "Company") return entityType;
  if(entityType === "Trust") return trustType!;
  return smmeType!;
}

export const getImageLocation = (image: string): string => {
  const url = window.location.href.split("?");
  return `${
    process.env.REACT_APP_ENVIRONMENT === "development" ? "" : `${url[0]}/dist/`
  }${image}`;
};
